module.exports = __webpack_public_path__ + "static/media/aboutUs_08.c45dde2f.jpg";